<div class="modal-header" style="display: block;">
    <div class="row" style="align-items: center;padding: 5px;">
      <div class="col-xs-10 col-sm-10 col-md-10">
        <h3 class="modal-title" style="margin: 0px !important;">
            <img
            src="/assets/images/patient_profile/transfer_no_corruption_icon_226109 1.svg" style="
                  border-radius: 4px;
                  width: 28px;" />
            <span class="h3 font-thin" style="color: #58666E;font-size: 22px;vertical-align: bottom;margin: 10px;">{{title}}</span>
        </h3>
      </div>
      <div class="col-xs-2 col-sm-2 col-md-2">
        <button style="border: none;outline: none;float: right;background: transparent" (click)="closeModal()"> <img
            src="/assets/images/close.svg" style="border-radius: 4px; width: 28px;" />
        </button>
      </div>
    </div>
  </div>
<div class="modal-body">
    <p class="sansSerifFont" style="color: #686767; font-size: 14px;">{{message}}</p>
</div>
<div class="modal-footer">                  
    <button class="btn sansSerifFont" (click)="closeModal()" style="border: 1px solid #e9e9e9;">No</button>
    <button [disabled]="loading" class="btn btn-addon m-t-n-xs ng-scope sansSerifFont" (click)="ok()"
    style="background-color: #5bac53; border-color: #5bac53;color: #ffffff">{{loading?'Loading': 'Yes'}}</button>
</div>